/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MediaTypeInput } from './mediaTypeInput';
import type { ExportedResourceInputUrl } from './exportedResourceInputUrl';
import type { ExportedResourceInputResourceId } from './exportedResourceInputResourceId';
import type { ExportedResourceInputResourceRef } from './exportedResourceInputResourceRef';
import type { ExportedResourceInputDigest } from './exportedResourceInputDigest';

/**
 * Resource in export format
 */
export interface ExportedResourceInput {
  title: string;
  description?: string;
  citation?: string;
  media_type: MediaTypeInput;
  url?: ExportedResourceInputUrl;
  resource_id?: ExportedResourceInputResourceId;
  resource_ref?: ExportedResourceInputResourceRef;
  digest?: ExportedResourceInputDigest;
  sort_order?: number;
  oral_exam_relevant?: boolean;
}
